import ClassicLibrary from './ClassicLibrary';
import { useLibrary } from './useLibrary';

export default function LibraryPage() {
  return <ClassicLibrary lib={useLibrary()} />;
}
